// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"561":"b8b9d34c078c1a6a","6681":"9dbff2e13711323a"}[chunkId] + ".css";
};